var _SpriteSymbol = require("/runner/_work/CertifyApp/CertifyApp/node_modules/rspack-plugin-svg-sprite/dist/runtime/symbol");
var SpriteSymbol = _SpriteSymbol.default || _SpriteSymbol;
var symbol = new SpriteSymbol({"id":"remove","viewBox":"0 -960 960 960","content":"<symbol id=\"remove\" viewBox=\"0 -960 960 960\"><path d=\"M223.869-438.5v-83h512.262v83H223.869Z\"/></symbol>"});
symbol.url = "/Scripts/dist/sprite.svg#remove";
export default symbol;
